import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Box, useMediaQuery, useTheme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  count: {
    fontSize: theme.typography.pxToRem(16),
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
}))

interface DiscoPromoProductsResultCountProps {
  itemCount: number
  pageStart: number
  pageEnd: number
  isSearchResult?: boolean
}

const DiscoPromoProductsResultCount: React.FC<
  DiscoPromoProductsResultCountProps
> = ({ pageStart, pageEnd, itemCount, isSearchResult = false }) => {
  const classes = useStyles()
  const theme = useTheme()
  const mediaQuerySMDown = useMediaQuery(theme.breakpoints.down('sm'))

  return isSearchResult || mediaQuerySMDown ? (
    <Box className={classes.count}>
      <FormattedMessage
        id="PAGINATION_SEARCH_RESULTS_SHOWING_TEXT"
        defaultMessage="Showing {pageStart}-{pageEnd} of {itemCount} results"
        values={{ pageStart, pageEnd, itemCount }}
      />
    </Box>
  ) : (
    <Box className={classes.count}>
      <FormattedMessage
        id="PAGINATION_RESULTS_SHOWING_TEXT"
        defaultMessage="Showing {pageStart}-{pageEnd} of {itemCount}"
        values={{ pageStart, pageEnd, itemCount }}
      />
    </Box>
  )
}

export default DiscoPromoProductsResultCount
